import { render, staticRenderFns } from "./errorePagamento.vue?vue&type=template&id=09be98af"
import script from "./errorePagamento.vue?vue&type=script&lang=js"
export * from "./errorePagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports